import * as React from 'react';
//static generic components
import './styles.scss';
import BodyPortal from '../BodyPortal';

export default class RightPopUpComponent extends React.Component {
    render(){
        if(!this.props.flag)
            return null;

        return(
        <BodyPortal>
                <div className="rightPanel removeLayer leftNavSection">
                <div className="transparentOverlay"  onClick={this.props.onClose}></div>
                <div className={`${this.props.panelType=="viewNotePanel" ? "rightPopupNotes" : "rightPopupContainer"} animated faster fadeInRight`}>
                    {this.props.children}
                </div>
            </div> 
        </BodyPortal>
    );
    }    
}
